import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { Plus, Minus, Search } from "lucide-react";
import SEO from "@/components/SEO";

export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);

  const filtered = useMemo(() => {
    if (!q.trim()) return faqs;
    const term = q.toLowerCase();
    return faqs.filter(f => f.question.toLowerCase().includes(term) || f.answer.toLowerCase().includes(term));
  }, [faqs, q]);

  return (
    <div data-testid="faq-page">
      <SEO
        title="Frequently Asked Questions"
        description="Common questions about ordering, delivery, subscriptions, cooking classes, and event chef bookings at AlikamaFish."
        path="/faq"
      />
      <section className="bg-[color:var(--color-primary)] text-white py-20">
        <div className="container-x px-6">
          <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--color-accent)] mb-4">Questions?</div>
          <h1 className="font-display text-5xl md:text-6xl">Frequently Asked</h1>
        </div>
      </section>
      <section className="section bg-[color:var(--color-bg)]">
        <div className="container-x max-w-3xl">
          <div className="relative mb-10">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search questions…"
              className="w-full pl-12 pr-4 py-3 border border-[color:var(--color-border)] rounded-lg bg-white focus:outline-none focus:border-[color:var(--color-primary)]"
              data-testid="faq-search"
            />
          </div>
          <div className="space-y-3">
            {filtered.length === 0 && <div className="text-center text-gray-500 py-12" data-testid="no-faqs">No matching questions.</div>}
            {filtered.map((f) => (
              <div key={f.id} className="bg-white border border-[color:var(--color-border)] rounded-lg overflow-hidden" data-testid={`faq-${f.id}`}>
                <button
                  onClick={() => setOpen(open === f.id ? null : f.id)}
                  className="w-full flex items-center justify-between text-left p-5"
                  data-testid={`faq-toggle-${f.id}`}
                >
                  <div>
                    <div className="text-xs uppercase tracking-widest text-[color:var(--color-accent)] mb-1">{f.category}</div>
                    <div className="font-display text-xl text-[color:var(--color-primary)]">{f.question}</div>
                  </div>
                  {open === f.id ? <Minus className="w-5 h-5 text-[color:var(--color-primary)]"/> : <Plus className="w-5 h-5 text-[color:var(--color-primary)]"/>}
                </button>
                {open === f.id && (
                  <div className="px-5 pb-5 text-[color:var(--color-text-secondary)] leading-relaxed border-t border-[color:var(--color-border)] pt-4">{f.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
